var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "prescription-page" },
    [
      _c("div", { staticClass: "breadcrumb" }, [
        _c(
          "div",
          { staticClass: "breadcrumb-content" },
          [
            _c("span", { staticClass: "active" }, [_vm._v("提交问诊信息")]),
            _c("icon", { attrs: { name: "arrow" } }),
            _c("span", [_vm._v("医生接诊开方")]),
            _c("icon", { attrs: { name: "arrow" } }),
            _c("span", [_vm._v("支付订单")]),
          ],
          1
        ),
      ]),
      false
        ? _c(
            "div",
            { staticClass: "address-item", on: { click: _vm.selectAddr } },
            [
              _c("div", { staticClass: "address-content" }, [
                _c("i", { staticClass: "iconfont icon-shdz" }),
                _vm.addressInfo.addressId
                  ? _c("div", { staticClass: "address-info" }, [
                      _c("h3", { staticClass: "address-name" }, [
                        _c("span", [_vm._v(_vm._s(_vm.addressInfo.addressee))]),
                        _c("span", { staticClass: "address-phone" }, [
                          _vm._v(_vm._s(_vm.addressInfo.phone)),
                        ]),
                      ]),
                      _c("p", { staticClass: "address-area" }, [
                        _vm._v(_vm._s(_vm.showArea(_vm.addressInfo))),
                      ]),
                    ])
                  : _c("div", { staticClass: "address-info" }, [
                      _c("h3", { staticClass: "address-area" }, [
                        _vm._v("请选择地址"),
                      ]),
                    ]),
                _c("div", { staticClass: "address-status" }, [
                  _c(
                    "p",
                    { staticClass: "view-details" },
                    [_c("icon", { attrs: { name: "arrow" } })],
                    1
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "user-info card-panel" }, [
        _c("div", { staticClass: "panel-header" }, [
          _c("h3", [_vm._v("用药人")]),
          _c(
            "div",
            {
              staticClass: "one-click",
              on: {
                click: function ($event) {
                  _vm.showMedicineList = true
                },
              },
            },
            [
              _c("icon", { attrs: { name: "plus" } }),
              _c("span", [_vm._v("选择/新建用药人")]),
              _c("icon", { attrs: { name: "arrow" } }),
            ],
            1
          ),
        ]),
        _vm.selectedMedicine
          ? _c("div", { staticClass: "form-content" }, [
              _c("div", { staticClass: "user-info-row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("真实姓名")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.selectedMedicine.name)),
                ]),
              ]),
              _c("div", { staticClass: "user-info-row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("手机号")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_vm.hideMiddleChars(_vm.selectedMedicine.phone))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "user-info-row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("身份证")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_vm.hideMiddleChars(_vm.selectedMedicine.idCard))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "user-info-row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("关系")]),
                _c("span", { staticClass: "tag" }, [
                  _vm._v(_vm._s(_vm.selectedMedicine.relTag)),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.orderInfo.sum
        ? _c(
            "div",
            { staticClass: "product-disease-list card-panel" },
            [
              _vm._m(0),
              _vm._l(_vm.products, function (product) {
                return _c(
                  "div",
                  { key: product.id, staticClass: "product-disease-item" },
                  [
                    _c("div", { staticClass: "product-disease-content" }, [
                      _c("div", { staticClass: "product-content" }, [
                        _c(
                          "div",
                          { staticClass: "item-img" },
                          [
                            _c("van-image", {
                              attrs: { fit: "cover", src: product.goodsIcon },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "product-details" },
                          [
                            _c("drugTag", { attrs: { product: product } }),
                            _c("p", { staticClass: "product-description" }, [
                              _vm._v(_vm._s(product.goodsFunction)),
                            ]),
                            _c("div", { staticClass: "product-foot" }, [
                              _c(
                                "span",
                                { staticClass: "product-price" },
                                [
                                  false
                                    ? _c("pointPrice", {
                                        attrs: { product: product },
                                      })
                                    : _vm._e(),
                                  _vm._v("￥" + _vm._s(product.salePrice)),
                                ],
                                1
                              ),
                              _c("span", [
                                _vm._v("x" + _vm._s(product.number)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "disease-info" },
                        [
                          _c(
                            "div",
                            { staticClass: "disease-tags" },
                            _vm._l(product.diseases, function (disease) {
                              return _c(
                                "span",
                                {
                                  key: disease.id,
                                  class: [
                                    "disease-tag",
                                    {
                                      active: product.selectedDiseases.includes(
                                        disease.diseaseId
                                      ),
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleDisease(
                                        disease.diseaseId,
                                        product
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(disease.diseaseName) + " "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          product.medicineType === "RX"
                            ? _c("van-field", {
                                attrs: {
                                  label: "手动输入疾病：",
                                  placeholder: "可自行输入疾病",
                                  clearable: "",
                                },
                                model: {
                                  value: product.manualDiseaseName,
                                  callback: function ($$v) {
                                    _vm.$set(product, "manualDiseaseName", $$v)
                                  },
                                  expression: "product.manualDiseaseName",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "upload-panel card-panel" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "upload-area" },
          [
            _c(
              "van-uploader",
              {
                attrs: { "max-count": 5, "after-read": _vm.afterRead },
                model: {
                  value: _vm.fileList,
                  callback: function ($$v) {
                    _vm.fileList = $$v
                  },
                  expression: "fileList",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "upload-button" },
                  [_c("icon", { attrs: { name: "plus" } })],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "bottom-fixed" }, [
        _c(
          "div",
          { staticClass: "agreement" },
          [
            _c(
              "van-checkbox",
              {
                attrs: { shape: "square" },
                model: {
                  value: _vm.agreement,
                  callback: function ($$v) {
                    _vm.agreement = $$v
                  },
                  expression: "agreement",
                },
              },
              [
                _vm._v(
                  " 我确认已确诊此疾病并使用过该药，且无过敏、无相关禁忌症和不良反应 "
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bottom-button" },
          [
            _c(
              "van-button",
              {
                attrs: { type: "danger", block: "", disabled: !_vm.agreement },
                on: { click: _vm.submitOrder },
              },
              [_vm._v(" 免费问诊开方 ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "van-popup",
        {
          style: { height: "80%", backgroundColor: "#f7f8fa" },
          attrs: { position: "bottom" },
          model: {
            value: _vm.showMedicineList,
            callback: function ($$v) {
              _vm.showMedicineList = $$v
            },
            expression: "showMedicineList",
          },
        },
        [_c("medicine-list", { on: { select: _vm.handleMedicineSelect } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _vm._v("选择线下已确诊疾病 "),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            color: "#ee0a24",
            "margin-left": "4px",
          },
        },
        [_vm._v("（每个药品至少选择一种）")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [
      _vm._v("处方/病历/检查报告"),
      _c("span", { staticClass: "subtitle" }, [_vm._v("（选填，最多5张）")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }